// PrivacyPolicy.js
import React from "react";
import { Box, Container, Typography } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#121212",
        color: "white",
        minHeight: "100vh",
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom align="center">
          Privacy Policy & Terms of Service
        </Typography>

        {/* 1. Introduction */}
        <Typography variant="h6" gutterBottom>
          1. Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          Welcome to TrueChamp. By using our app, you agree to the terms and policies outlined below.
        </Typography>

        {/* 2. Data Collection & Use */}
        <Typography variant="h6" gutterBottom>
          2. Data Collection & Use
        </Typography>
        <Typography variant="body1" paragraph>
          We collect information such as your name, email, username, profile photo, and check-in images.
          This data is used solely for providing and improving the app experience. We do not sell or
          share your data with third parties without your consent.
        </Typography>

        {/* 3. Security */}
        <Typography variant="h6" gutterBottom>
          3. Security
        </Typography>
        <Typography variant="body1" paragraph>
          We use secure storage methods, Firebase Authentication, Render for backend, MongoDB for data,
          and AWS S3 for image storage. We strive to protect your personal data at all times.
        </Typography>

        {/* 4. Image Storage & Access */}
        <Typography variant="h6" gutterBottom>
          4. Image Storage & Access
        </Typography>
        <Typography variant="body1" paragraph>
          Images are stored safely on AWS S3. Images are accessible only via app functions and not
          publicly. App admins may access images for moderation and technical troubleshooting purposes.
        </Typography>

        <Typography variant="body2" paragraph sx={{ mt: 2, opacity: 0.8 }}>
          By continuing, you agree to our Privacy Policy and Terms of Service.
        </Typography>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
